import { gsap } from 'gsap'

export default class Slideshow {
  constructor(slides) {
    this.slides = []
    this.current = 0
    this.isAnimating = false

    slides.forEach(obj => {
      this.slides.push({
        id: this.slides.length,
        current: false,
        data: obj,
        headerOpacity: 1,
        opacity: 1,
        x0: 0,
        y0: 0,
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        x3: 0,
        y3: 0,
      })
    })
    this.slidesTotal = this.slides.length

    this.positions = {
      x: {
        next: [-50, 0, 0, 50],
        prev: [0, 50, -50, 0],
      },
      y: {
        next: [0, -50, 50, 0],
        prev: [-50, 0, 0, 50],
      },
    }
  }

  navigate(direction) {
    if (this.isAnimating) {
      return false
    }

    const currentSlide = this.slides[this.current]

    const updatedIndex =
      direction === 'next'
        ? this.current < this.slidesTotal - 1
          ? this.current + 1
          : 0
        : this.current > 0
        ? this.current - 1
        : this.slidesTotal - 1

    const nextSlide = this.slides[updatedIndex]

    this.isAnimating = true

    function setCurrentSlide() {
      this.current = updatedIndex
    }

    gsap
      .timeline({
        defaults: { duration: 1, ease: 'power4.inOut' },
        onComplete: () => {
          this.isAnimating = false
        },
      })
      .to(currentSlide, {
        opacity: 0,
        x0: this.positions.x[direction][0],
        x1: this.positions.x[direction][1],
        x2: this.positions.x[direction][2],
        x3: this.positions.x[direction][3],
        y0: this.positions.y[direction][0],
        y1: this.positions.y[direction][1],
        y2: this.positions.y[direction][2],
        y3: this.positions.y[direction][3],
      })
      .to(currentSlide, {
        duration: 0.4,
        headerOpacity: 0,
      })
      .call(setCurrentSlide.bind(this))
      .to(nextSlide, {
        ease: 'power4',
        startAt: {
          opacity: 0,
          headerOpacity: 0,
          x0: this.positions.x[this.reverseDirection(direction)][0],
          x1: this.positions.x[this.reverseDirection(direction)][1],
          x2: this.positions.x[this.reverseDirection(direction)][2],
          x3: this.positions.x[this.reverseDirection(direction)][3],
          y0: this.positions.y[this.reverseDirection(direction)][0],
          y1: this.positions.y[this.reverseDirection(direction)][1],
          y2: this.positions.y[this.reverseDirection(direction)][2],
          y3: this.positions.y[this.reverseDirection(direction)][3],
        },
        headerOpacity: 1,
        opacity: 1,
        x0: 0,
        x1: 0,
        x2: 0,
        x3: 0,
        y0: 0,
        y1: 0,
        y2: 0,
        y3: 0,
      })
  }
  reverseDirection(direction) {
    return direction === 'next' ? 'prev' : 'next'
  }
}
